import { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { CltManutation } from "./manutation";
import { ProviderOrderPanel } from "./providerorder";
import { ConsultLimitPanel } from "./consultlimit";
import { ConsultHourPanel } from "./consulthour";
import { OfflineRulesPanel } from "./offlinerules";
import { SumaConfigPanel } from "./sumaconfig";
import { CltErrorLogsPanel } from "./errorlogs";
import { CltConsultsPanel } from "./consults";
import { DataPrevHistoryPanel } from "./dataprevhistory";
import { SumaShotDebugPanel } from "./sumashootdebug";
import { ListClearPanel } from "./listclear";

const divider = <hr style={{ margin: '24px auto', maxWidth: 520, border: 'none', borderTop: '1px solid #00000020' }} />;

export function CltSettings(){
    const [tab, setTab] = useState(0);
    return (<div>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto" centered>
                <Tab label="Configurações" />
                <Tab label="Logs de erro" />
                <Tab label="Consultas" />
                <Tab label="DataPrev" />
                <Tab label="Debug Shots" />
                <Tab label="Limpeza de lista" />
            </Tabs>
        </Box>

        {tab === 0 && (<div>
            <CltManutation/>
            {divider}
            <ProviderOrderPanel/>
            {divider}
            <ConsultLimitPanel/>
            {divider}
            <ConsultHourPanel/>
            {divider}
            <OfflineRulesPanel/>
            {divider}
            <SumaConfigPanel/>
        </div>)}
        {tab === 1 && <CltErrorLogsPanel/>}
        {tab === 2 && <CltConsultsPanel/>}
        {tab === 3 && <DataPrevHistoryPanel/>}
        {tab === 4 && <SumaShotDebugPanel/>}
        {tab === 5 && <ListClearPanel/>}
    </div>)
}